import { createContext } from 'react';

interface FieldContextParams {
    nonValidationError: React.ReactNode;
    setNonValidationError: (error: React.ReactNode) => void;
}

export const FormFieldContext = createContext<FieldContextParams>({
    nonValidationError: '',
    setNonValidationError: () => undefined,
});
